import React, { useLayoutEffect, useState, useRef } from "react";
import { Form, Input, Button, message, Select, TimePicker, Radio } from "antd";
import { toast } from "react-toastify";
import dayjs, { Dayjs } from "dayjs";
import { Card, CardHeader, CardTitle } from "../../../../components/ui/card";
import {
  ARRIVED,
  CONSULTING,
  DAY,
  DONE,
  EVENING,
  FOLLOW_UP,
  HAS_APPOINTMENT,
  IN_PROGRESS,
  IN_XRAY,
  PAID,
  WAITING_FOR_XRAY,
} from "../../../CONSTANTS";
import { ValidateErrorEntity } from "rc-field-form/lib/interface";
import { addAppointment } from "../../../networkCalls";
import { AxiosError } from "axios";
import {
  checkIfStringIsEmpty,
  convertErrorResponseToMessage,
  showToastType,
} from "../../../utils";
import { start } from "repl";
import { RadioGroup, tabClasses } from "@mui/material";
import {
  getAppointmentSlotsAndSetTimes,
  getNextAvailableTime,
} from "../../utils";
import {
  ConsultingSlot,
  ConsultingSlotsType,
  PatientDetailsType,
} from "../../types";

var LocalizedFormat = require("dayjs/plugin/localizedFormat");

dayjs.extend(LocalizedFormat);
type PatientAppointmentDetailsType = {
  firstname: string;
  lastname: string;
  phonenumber: string;
  appointmentType: string;
  appointmentStatus: string;
  appointmentTimes: string;
  consultingSlot: string;
};

export function AddPatientToAppointment({
  patientDetails,
  current,
  setCurrent,
  setPatientDetails,
  availableSlots,
  readableAppointmentTimes,
  setConsultingSlot,
  consultingSlot,
  setAvailableAppointmentSlots,
  setReadableAppointmentTimes,
  form,
}: {
  patientDetails: PatientDetailsType;
  current: number;
  setCurrent: any;
  setPatientDetails: any;
  availableSlots: ConsultingSlotsType[];
  readableAppointmentTimes: string[];
  setConsultingSlot: any;
  consultingSlot: string;
  setAvailableAppointmentSlots: any;
  setReadableAppointmentTimes: any;
  form: any;
}) {
  // const [form] = Form.useForm();
  const [timeError, setTimeError] = useState({
    error: false,
    message: "",
  });

  function onFinish(values: PatientAppointmentDetailsType) {
    // Add appointment Endpoint
    if (checkIfStringIsEmpty(values.appointmentTimes)) {
      toast.error(
        "Could Not load Empty appointment times. Please Refresh the page"
      );
    } else {
      var patientFirstName = values.firstname;
      var patientLastName = values.lastname;
      var patientPhoneNumber = values.phonenumber;

      var appointmentStatus = values.appointmentStatus;

      var consultingSlot = values.consultingSlot;

      var selectedtime = readableAppointmentTimes.indexOf(
        values.appointmentTimes
      );
      var appointmentStartTime = availableSlots[selectedtime].start;
      var appointmentEndTime = availableSlots[selectedtime].end;
      if (patientFirstName === undefined || patientFirstName.length === 0) {
        toast.error("Patient First name cannot be empty");
      } else {
        addAppointment(
          patientFirstName,
          patientLastName,
          patientPhoneNumber,
          appointmentStartTime,
          appointmentEndTime,

          appointmentStatus,
          consultingSlot
        )
          .then((addedAppointment) => {
            toast.success(
              `Appointment Successfully Added For: ${values.firstname}`
            );
            form.resetFields();
            setConsultingSlot(EVENING);
            setPatientDetails({
              firstName: "",
              lastName: "",
              phoneNumber: "",
              appointmentStatus: HAS_APPOINTMENT,
              consultingSlot: EVENING,
              appointmentTimes: "",
            });
            getAppointmentSlotsAndSetTimes(
              consultingSlot,
              setAvailableAppointmentSlots,
              setReadableAppointmentTimes
            );
          })
          .catch((error) => {
            if (error instanceof AxiosError) {
              const addPatientErrorObject =
                convertErrorResponseToMessage(error);
              const message = addPatientErrorObject["message"];
              const status = addPatientErrorObject["statusCode"];
              showToastType(message, status);
            } else if (
              error.hasOwnProperty("response") &&
              error.response.hasOwnProperty("data") &&
              error.response.data.hasOwnProperty("message")
            ) {
              var errorMessage = error.message;
              errorMessage = error.response.data.message;
              toast.error(errorMessage);
            } else {
              toast.error("Unexpected Error occured. Please try again");
            }
          });
      }
    }
  }
  function onValuesChange(values: PatientAppointmentDetailsType) {
    if (values !== undefined && values.consultingSlot) {
      setConsultingSlot(values.consultingSlot);
    }
  }
  return (
    <Card
      className="static pt-2 sm:w-96 md:w-96 
    lg:w-96 xl:w-96 2xl:w-96 z-10
     mx-auto text-center rounded-lg shadow-2xl backdrop-blur-sm"
    >
      <CardHeader>
        <CardTitle>Add Patient and Appointment</CardTitle>
      </CardHeader>
      <Form
        form={form}
        {...layout}
        className="staff-search-patient-form px-3 mx-1"
        size={"middle"}
        onValuesChange={onValuesChange}
        preserve={false}
        initialValues={{
          firstname: patientDetails.firstName,
          lastname: patientDetails.lastName,
          phonenumber: patientDetails.phoneNumber,
          // appointmentType: patientDetails.appointmentType,
          appointmentStatus: patientDetails.appointmentStatus,
          consultingSlot: patientDetails.consultingSlot,
          appointmentTimes: patientDetails.appointmentTimes,
        }}
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="firstname"
          label="Patient First Name"
          rules={[
            { type: "regexp", pattern: RegExp("[a-z|A-Z|s|S]*") },
            { required: true, message: "Please input your Firstname" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="lastname" label="Patient Last Name">
          <Input />
        </Form.Item>
        <Form.Item
          name="phonenumber"
          label="Patient Phone Number"
          // rules={[
          //   {
          //     type: "regexp",
          //     pattern: RegExp("[0-9]{11}|[0-9]{10}", "g"),
          //     message: "Phone Number should be in format",
          //   },
          // ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="appointmentStatus" label="Appointment Status">
          <Select
            style={{ width: 170 }}
            options={[
              { value: HAS_APPOINTMENT, label: "Has Appointment" },
              { value: ARRIVED, label: "Arrived" },
              { value: IN_PROGRESS, label: "In Progress" },
              { value: WAITING_FOR_XRAY, label: "Waiting For Xray" },
              { value: IN_XRAY, label: "In Xray Room" },
            ]}
          />
        </Form.Item>
        <Form.Item name="consultingSlot" label="Consulting Slot">
          <Radio.Group buttonStyle="solid">
            <Radio.Button value={DAY}>DAY</Radio.Button>
            <Radio.Button value={EVENING}>EVENING</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="appointmentTimes"
          label="Appointment Time"
          rules={[{ required: true, message: "Appointment Time is required" }]}
        >
          <Radio.Group buttonStyle="solid">
            {availableSlots.length !== 0
              ? readableAppointmentTimes.map((slot) => {
                  return (
                    <Radio.Button key={slot} value={slot}>
                      {slot}
                    </Radio.Button>
                  );
                })
              : defaultSlot(
                  patientDetails.consultingSlot === EVENING
                    ? ConsultingSlot.EVENING
                    : ConsultingSlot.DAY
                )}
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" danger>
            Add Appointment
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}
const layout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 24 },
};
function defaultSlot(consultingSlot: ConsultingSlot) {
  const appointmentStartEndTimes = getNextAvailableTime(consultingSlot);
  return (
    <Radio.Button
      value={{
        start: appointmentStartEndTimes.end,
        end: dayjs(appointmentStartEndTimes.end).add(5, "minute").toISOString(),
      }}
    >
      {dayjs(appointmentStartEndTimes.end).format("LT")}
    </Radio.Button>
  );
}
